import React from 'react';
import PropTypes from 'prop-types';
import {v4 as uuidv4} from 'uuid';
import {convertLabelTextToDataTestId} from "../../utils/convertLabelTextToDataTestId";

const OptionalTextBox = ({
                             onCheckBoxChange,
                             onTextBoxChange,
                             checkBoxIsChecked,
                             textInput,
                             checkboxText,
                             labelText,
                             helpText,
                             maxTextLength,
                             unsetValueOnUnCheck = true
                         }) => {

    const UUID = uuidv4();
    const checkBoxId = `checkbox-${UUID}`;

    const checkBoxChanged = isChecked => {
        onCheckBoxChange(isChecked)
        if (!isChecked && unsetValueOnUnCheck) {
            onTextBoxChange(undefined)
        }
    };

    return <>
        <div className="checkbox-container scaffolding-dag">
            <input className="checkbox test"
                   type="checkbox"
                   id={checkBoxId}
                   checked={checkBoxIsChecked}
                   onChange={() => checkBoxChanged(!checkBoxIsChecked)}
            />
            <label className={'checkbox-label'} htmlFor={checkBoxId}>{checkboxText}</label>
        </div>
        <div className={'id-input'}>
            <span className='input-group-label'>{labelText}:</span>
            <input
                id={'alternate-source-identifier-input'}
                data-testid={convertLabelTextToDataTestId(labelText, undefined, "_input")}
                disabled={!checkBoxIsChecked}
                className={'input-group-field'}
                type='text'
                value={textInput || ''}
                maxLength={maxTextLength}
                onChange={(e) => onTextBoxChange(e.target.value)}
            />
        </div>
        <div className="help-text">{helpText}</div>
    </>;
}


OptionalTextBox.propTypes = {
    onCheckBoxChange: PropTypes.func.isRequired,
    onTextBoxChange: PropTypes.func.isRequired,
    checkBoxIsChecked: PropTypes.bool.isRequired,
    textInput: PropTypes.string,
    checkboxText: PropTypes.string,
    labelText: PropTypes.string,
    helpText: PropTypes.string,
    maxTextLength: PropTypes.number,
    unsetValueOnUnCheck: PropTypes.bool
}


export default OptionalTextBox
